export const AVAILABLE = 'internetAvailable'
export const UNDER_CONSTRUCTION = 'underConstruction'
export const UNAVAILABLE = 'internetUnavailable'
export const ALREADY_REGISTERED = 'alreadyRegistered'
export const COMPLETE = 'complete'

export default {
	AVAILABLE,
	UNDER_CONSTRUCTION,
	UNAVAILABLE,
	ALREADY_REGISTERED,
	COMPLETE
}
